module.exports = __webpack_public_path__ + "fonts/sgds-icons.woff";